import type { Locale } from '@/features/basket/types/locale';

export enum Redirect {
  LOGIN = 'login',
  HELP = 'help',
  PRIVACY = 'privacy',
  REGULATIONS = 'regulations',
  RETURNS = 'returns',
  ORDERS = 'orders',
  BLOG = 'blog',
  INSTAGRAM = 'instagram',
  FACEBOOK = 'facebook',
  TIKTOK = 'tiktok',
  LINKEDIN = 'linkedin',
  YOUTUBE = 'youtube',
  OUR_STORES = 'our_stores',
  ABOUT_US = 'about_us',
  SEARCH = 'search',
}

type RedirectsPathMap = {
  [key in Redirect]: Record<Locale, string>;
};

const redirectsPathMap: RedirectsPathMap = {
  [Redirect.LOGIN]: {
    pl: '/uzytkownik/login',
    ee: '/kasutajad/logi-sisse',
    fi: '/kayttajat/kirjaudu-sisaan-tilille',
    lt: '/vartotojas/prisijungti',
    lv: '/lietotajs/ienakt',
    'ru-lv': '/ru/polzovatel/vojti/',
    'ru-ee': '/ru/polzovatel/vojti/',
  },
  [Redirect.HELP]: {
    pl: '/pomoc',
    ee: '/korduma-kippuvad-kusimused',
    fi: '/faq',
    lt: '/kontaktai',
    lv: '/biezak-uzdotie-jautajumi',
    'ru-lv': '/ru/casto-zadavaemye-voprosy/',
    'ru-ee': '/ru/casto-zadavaemye-voprosy/',
  },
  [Redirect.PRIVACY]: {
    pl: '/polityka-prywatnosci',
    ee: '/privaatsuspoliitika',
    fi: '/rekisteriseloste/',
    lt: '/privatumo-politika',
    lv: '/privatuma-politika',
    'ru-lv': '/ru/politika-konfidencialnosti-ds/',
    'ru-ee': '/ru/politika-konfidencialnosti/',
  },
  [Redirect.REGULATIONS]: {
    pl: '/regulamin',
    ee: '/tingimused',
    fi: '/kayttoehdot-sopimusehdot/',
    lt: '/bendrosios-naudojimo-salygos',
    lv: '/nosacijumi',
    'ru-lv': '/ru/uslovija-pokupki/',
    'ru-ee': '/ru/uslovija-pokupki/',
  },
  [Redirect.RETURNS]: {
    pl: '/pomoc/#C5',
    ee: '/korduma-kippuvad-kusimused/',
    fi: '/faq/',
    lt: '/vartotojas/prisijungti',
    lv: '/biezak-uzdotie-jautajumi/',
    'ru-lv': '/ru/casto-zadavaemye-voprosy/',
    'ru-ee': '/ru/casto-zadavaemye-voprosy/',
  },
  [Redirect.ORDERS]: {
    pl: '/uzytkownik/zamowienia',
    ee: '/kasutajad/tellimuste-ajalugu/',
    fi: '/kayttajat/tilaukset',
    lt: '/vartotojas/uzsakymu-istorija',
    lv: '/lietotajs/pasutijumu-arhivs',
    'ru-lv': '/ru/polzovatel/istorija-zakazov',
    'ru-ee': '/ru/polzovatel/istorija-zakazov/',
  },
  [Redirect.BLOG]: {
    pl: '/blog',
    ee: '/blogi',
    fi: '/blogi',
    lt: '/blogas',
    lv: '/blogs',
    'ru-lv': '/blogs/',
    'ru-ee': '/blogi/',
  },
  [Redirect.INSTAGRAM]: {
    pl: 'https://www.instagram.com/wyjatkowyprezent/',
    ee: 'https://www.instagram.com/kingitus.ee/',
    fi: 'https://www.instagram.com/elamyslahjat/',
    lt: 'https://www.instagram.com/laisvalaikiodovanos/',
    lv: 'https://www.instagram.com/davanuserviss/',
    'ru-lv': 'https://www.instagram.com/davanuserviss/',
    'ru-ee': 'https://www.instagram.com/kingitus.ee/',
  },
  [Redirect.FACEBOOK]: {
    pl: 'https://www.facebook.com/wyjatkowyprezent/',
    ee: 'https://www.facebook.com/Kingitus.ee',
    fi: 'https://www.facebook.com/elamyslahjat',
    lt: 'https://www.facebook.com/LaisvalaikioDovanos.lt',
    lv: 'https://www.facebook.com/DavanuServiss',
    'ru-lv': 'https://www.facebook.com/DavanuServiss',
    'ru-ee': 'https://www.facebook.com/Kingitus.ee',
  },
  [Redirect.TIKTOK]: {
    pl: 'https://www.tiktok.com/@wyjatkowyprezent',
    fi: 'https://www.tiktok.com/@elamyslahjat',
    lt: 'https://www.tiktok.com/@laisvalaikiodovanos',
    lv: 'https://www.tiktok.com/@davanuserviss',
    ee: 'https://www.tiktok.com/@kingitus.ee',
    'ru-lv': 'https://www.tiktok.com/@davanuserviss',
    'ru-ee': 'https://www.tiktok.com/@kingitus.ee',
  },
  [Redirect.LINKEDIN]: {
    pl: 'https://pl.linkedin.com/company/wyj%C4%85tkowy-prezent',
    fi: 'https://www.linkedin.com/company/2743108/admin/feed/posts/',
    lt: 'https://www.linkedin.com/company/laisvalaikiodovanos-lt/',
    lv: 'https://www.linkedin.com/company/davanuserviss/',
    ee: 'https://www.linkedin.com/company/kingitusee/',
    'ru-lv': 'https://www.linkedin.com/company/davanuserviss/',
    'ru-ee': 'https://www.linkedin.com/company/kingitusee/',
  },
  [Redirect.YOUTUBE]: {
    pl: 'https://www.youtube.com/user/wyjatkowyprezent',
    fi: 'https://www.youtube.com/@elamyslahjat',
    lt: 'https://www.youtube.com/@laisvalaikiodovanos',
    lv: 'https://www.youtube.com/@davanuserviss107',
    ee: 'https://www.youtube.com/@Elamuskingitused',
    'ru-lv': 'https://www.youtube.com/@davanuserviss107',
    'ru-ee': 'https://www.youtube.com/@Elamuskingitused',
  },
  [Redirect.OUR_STORES]: {
    pl: '/nasze-sklepy',
    fi: '/salepoints',
    lt: '/parduotuves',
    lv: '/veikali',
    ee: '/kingipoed',
    'ru-lv': '/ru/veikali',
    'ru-ee': '/ru/kingipoed',
  },
  [Redirect.ABOUT_US]: {
    pl: '/o-firmie',
    fi: '/tietoa-meista',
    lt: '/laisvalaikio-dovanos',
    lv: '/par-mums',
    ee: '/meist',
    'ru-lv': '/par-mums',
    'ru-ee': '/meist',
  },
  [Redirect.SEARCH]: {
    pl: 'https://www.wyjatkowyprezent.pl/wyniki-wyszukiwania',
    fi: 'https://www.elamyslahjat.fi/hakutulokset',
    lt: 'https://www.laisvalaikiodovanos.lt/paieska',
    lv: 'https://www.davanuserviss.lv/meklesanas-rezultati',
    ee: 'https://www.kingitus.ee/tulemused',
    'ru-lv': 'https://www.davanuserviss.lv/meklesanas-rezultati',
    'ru-ee': 'https://www.kingitus.ee/tulemused',
  },
};

export const getRedirectPath = (type: Redirect, locale: Locale) =>
  redirectsPathMap[type][locale] ?? '/';
